import i18n from '@/i18n'

const data = () => {
    return {
        tabs: [
            {
                id: 'sent',
                title: i18n.t('profile.feedback.sent'),
                active: false,
                badge: false,
            },
            {
                id: 'received',
                title: i18n.t('profile.feedback.received'),
                active: false,
                badge: false,
            },
            {
                id: 'pending',
                title: i18n.t('profile.feedback.pending'),
                active: false,
                badge: true,
            },
        ],
        activeTab: '',
    }
}

export default data
